var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirewall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C9.68333 21.4167 7.771 20.0873 6.263 18.012C4.75433 15.9373 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.246 15.9373 17.738 18.012C16.2293 20.0873 14.3167 21.4167 12 22ZM12 19.9C13.6167 19.4 14.9667 18.4127 16.05 16.938C17.1333 15.4627 17.7667 13.8167 17.95 12H12V4.125L6 6.375V11.55C6 11.6667 6.01667 11.8167 6.05 12H12V19.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewall);
export default __webpack_public_path__ + "static/media/firewall.265b594c.svg";
export { ForwardRef as ReactComponent };